import { render, staticRenderFns } from "./ConfigurationStatusTable.vue?vue&type=template&id=6ad16f20"
import script from "./ConfigurationStatusTable.vue?vue&type=script&lang=js"
export * from "./ConfigurationStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports